import { create } from 'zustand'
import { shopApi } from '~/src/shared/api/shopApi'
import { useCartStore } from '~/src/features/cart/stores/useCartStore'

export const useSessionStore = create((set) => ({
  customer: null,
  loading: false,
  error: null,
  hydrate: async () => {
    set({ loading: true, error: null })
    try {
      const response = await shopApi.session()
      set({ customer: response.customer, loading: false })
    } catch (error) {
      set({ error: error.message, loading: false })
    }
  },
  login: async (payload) => {
    set({ loading: true, error: null })
    try {
      const response = await shopApi.login(payload)
      await useCartStore.getState().hydrate()
      set({ customer: response.customer, loading: false })
    } catch (error) {
      set({ error: error.message, loading: false })
      throw error
    }
  },
  register: async (payload) => {
    set({ loading: true, error: null })
    try {
      const response = await shopApi.register(payload)
      await useCartStore.getState().hydrate()
      set({ customer: response.customer, loading: false })
    } catch (error) {
      set({ error: error.message, loading: false })
      throw error
    }
  },
  logout: async () => {
    set({ loading: true, error: null })
    try {
      await shopApi.logout()
      await useCartStore.getState().hydrate()
      set({ customer: null, loading: false })
    } catch (error) {
      set({ error: error.message, loading: false })
      throw error
    }
  },
  requestOtp: async (payload) => {
    set({ loading: true, error: null })
    try {
      const response = await shopApi.requestOtp(payload)
      set({ loading: false })
      return response.otp_verification
    } catch (error) {
      set({ error: error.message, loading: false })
      throw error
    }
  },
  verifyOtp: async (payload) => {
    set({ loading: true, error: null })
    try {
      const response = await shopApi.verifyOtp(payload)
      await useCartStore.getState().hydrate()
      set({ customer: response.customer, loading: false })
      return response
    } catch (error) {
      set({ error: error.message, loading: false })
      throw error
    }
  },
}))
